import { mapJsonQueryBoolTerm } from './mapBoolTerm';
import { mapJsonQueryCompilationType } from './mapCompilationType';
import { mapJsonQueryNumberTerm } from './mapNumberTerm';
import { mapJsonQueryNumberTerms } from './mapNumberTerms';
import { mapPromoType } from './mapPromoType';
import { mapSort } from './mapSort';
import { IJsonQuerySchema } from '../../repositories/newbuilding-promos/entities/json_query/JsonQuerySchema';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';

export const mapJsonQuery = (jsonQuery: IJsonQuerySchema): IJsonQuery => {
  return {
    bankIds: mapJsonQueryNumberTerms(jsonQuery.bankIds),
    builderIds: mapJsonQueryNumberTerms(jsonQuery.builderIds),
    isFromBank: mapJsonQueryBoolTerm(jsonQuery.isFromBank),
    isFromBuilder: mapJsonQueryBoolTerm(jsonQuery.isFromBuilder),
    newbuildingIds: mapJsonQueryNumberTerms(jsonQuery.newbuildingIds),
    page: mapJsonQueryNumberTerm(jsonQuery.page),
    compilation: mapJsonQueryCompilationType(jsonQuery.compilation),
    promoType: mapPromoType(jsonQuery.promoType),
    sort: mapSort(jsonQuery.sort),
  };
};
